import styled from 'styled-components';
import { MainBtnLink } from 'components/Buttons';

export const SupportMaterialWrapper = styled.div`
  margin-top: 80px;
  background: linear-gradient(
    281.98deg,
    rgba(235, 161, 198, 0.5) 0%,
    #ffeaf6 69.75%
  );
  padding-top: 50px;
  padding-bottom: 80px;

  @media (max-width: 768px) {
    margin-top: 50px;
  }

  .title-support {
    margin-bottom: 20px;

    h1 {
      font-family: 'Inter Bold';
      font-size: var(--font-largest);
    }
  }
`;

export const CardsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 2%;
`;

export const Card = styled.div`
  border-radius: 15px;
  padding: 15px;
  margin-bottom: 30px;
  width: 32%;
  background-color: #fff;

  @media (max-width: 768px) {
    width: 49%;
  }

  .material-image {
    border-radius: 15px;
    position: relative;
    margin-bottom: 20px;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .material-type {
      position: absolute;
      top: 5px;
      right: 5px;
      color: var(--primary-color);
      background-color: var(--color-light-pink);
      border-radius: 25px;
      padding: 4px 14px;
      font-size: var(--font-smallest);
    }
  }

  .material-description {
    font-size: var(--font-medium);
    margin-bottom: 15px;

    @media (max-width: 768px) {
      font-size: var(--font-normal);
    }
  }
`;

export const MainBtn = styled(MainBtnLink)`
  @media (max-width: 768px) {
    height: 38px;
    padding: 0 18px;
  }
`;
